import React from "react";

import { Tooltip } from "@material-ui/core";
import { green, orange } from "@material-ui/core/colors";

import { InventoryStatus } from "../../../utils/constants";
import {
  BlankIcon,
  ErrorFilledIcon,
  WarningIcon,
} from "../../../components/common/iconography";

export const ValidateRequiredIcon = ({ record, classes, ...props }) => {
  if (!record) return null;
  else if (record.status === InventoryStatus.IN_TRANSIT)
    return <BlankIcon color="disabled" />;
  else
    return record.verificationRequired === "true" ? (
      <Tooltip title="Approval Required" placement="right" arrow>
        <WarningIcon className={classes} style={{ color: orange[600] }} />
      </Tooltip>
    ) : record.verificationRequired === "resolved" ? (
      <Tooltip title="Verified, Accepted" placement="right" arrow>
        <ErrorFilledIcon className={classes} style={{ color: green[600] }} />
      </Tooltip>
    ) : (
      <BlankIcon color="disabled" />
    );
};
